// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/calendar.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_schedules_v1_resources_calendar_day } from "./calendar_day_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/calendar.proto.
 */
export const file_studyo_today_schedules_v1_resources_calendar = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9jYWxlbmRhci5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMi8AEKCENhbGVuZGFyEiQKCXN0YXJ0X2RheRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSIgoHZW5kX2RheRgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSRwoNY2FsZW5kYXJfZGF5cxgDIAMoCzIwLnN0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzLkNhbGVuZGFyRGF5EiMKG2luY2x1ZGVkX3NjaGVkdWxlX2N5Y2xlX2lkcxgEIAMoCRIsCiRtb3JlX3JlY2VudF9kcmFmdF9zY2hlZHVsZV9jeWNsZV9pZHMYBSADKAlCK6oCKFN0dWR5by5Ub2RheS5TY2hlZHVsZXMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_type_date, file_studyo_today_schedules_v1_resources_calendar_day]);

/**
 * Describes the message studyo.today.schedules.v1.resources.Calendar.
 * Use `create(CalendarSchema)` to create a new message.
 */
export const CalendarSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_calendar, 0);

